import { render, staticRenderFns } from "./ExportButton.vue?vue&type=template&id=0ff519d0&scoped=true"
import script from "./ExportButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff519d0",
  null
  
)

export default component.exports